import React from "react"
import { useSelector } from "react-redux"

import { formatMoney } from "@/helpers/money"
import { displayPrecision } from "@/onboarding/features/product/helpers"
import { getProductNetCurrencyCode } from "@/onboarding/features/product/selectors"

const RateDisplay = ({
  amount,
  showPrevious = false,
}: {
  amount: number
  showPrevious?: boolean
}): JSX.Element => {
  const currency = useSelector(getProductNetCurrencyCode)
  const displayedAmount = displayPrecision(amount)

  return (
    <span style={showPrevious ? { color: "#00448c" } : undefined}>
      {isNaN(displayedAmount) ? "-" : formatMoney(displayedAmount, currency)}
    </span>
  )
}

export default RateDisplay
